import { useRouter } from "next/router";
import { constants, useWindowSize } from "@newsela/angelou";
import ShareAction from "@/view/SecondaryActions/ShareAction";

import BookmarkButton from "@/components/BookmarkButton";
import getContentLabel from "@/utils/getContentLabel";
import { LangstonContentResponse } from "@/types/models";
import { Bundle } from "@/types/models/Bundle.interface";
import {
  headerActionsContainerStyles,
  bookmarkIconStyles,
  shareActionWrapperStyles,
  popupOverridesStyles,
} from "./HeaderActions.style";

// Small TS-only utility to check if the content is a Bundle
function isBundleAPIResponse(data: unknown): data is Bundle {
  return typeof data === "object" && data !== null && "label" in data;
}

const CONTENT_LABELS = {
  BROWSE_PAGE: "Browse page",
  ROW: "Row",
};

const HeaderActions = ({
  content,
}: {
  content: LangstonContentResponse | null | undefined;
}) => {
  const { width: windowWidth } = useWindowSize();
  const {
    breakpoints: {
      Breakpoints: { lg },
    },
  } = constants;
  const isMobile = windowWidth <= lg;

  const router = useRouter();
  const { query } = router;
  const { currentContentId } = query as {
    currentContentId?: string;
  };

  const contentTypeLabel = getContentLabel({
    content_type: content?.data?.content_type || "BUNDLE",
    label: "",
  });

  let label: string | undefined;

  if (isBundleAPIResponse(content?.data)) {
    label = content?.data.label;
  }

  const shouldHideActions =
    label === CONTENT_LABELS.BROWSE_PAGE || label === CONTENT_LABELS.ROW;

  if (shouldHideActions) return null;

  return (
    <div css={headerActionsContainerStyles}>
      <div>
        <BookmarkButton
          contentId={currentContentId}
          iconColor="currentColor"
          hoverLabel="Save"
          __cssFor={{
            Icon: bookmarkIconStyles,
          }}
        />
      </div>
      <div css={shareActionWrapperStyles}>
        <ShareAction
          contentId={currentContentId}
          contentType={contentTypeLabel}
          title={content?.data?.name || ""}
          hoverLabel="Share"
          isMobile={isMobile}
          thumbnail={content?.data?.thumbnail || ""}
          popupOverrides={popupOverridesStyles}
        />
      </div>
    </div>
  );
};

export default HeaderActions;
